<div class="login-container">
  <button
    mat-icon-button
    type="button"
    class="theme-toggle"
    [attr.aria-label]="(isDarkMode$ | async) ? 'Enable light mode' : 'Enable dark mode'"
    (click)="toggleTheme()">
    <mat-icon>{{ (isDarkMode$ | async) ? 'light_mode' : 'dark_mode' }}</mat-icon>
  </button>
  <mat-card class="login-card">
    <div class="otp-branding">
      <ng-container *ngIf="isBrandingLoading; else resolvedOtpBranding">
        <div class="logo-loading-placeholder" aria-label="Loading organization branding">
          <mat-spinner diameter="24"></mat-spinner>
        </div>
      </ng-container>
      <ng-template #resolvedOtpBranding>
        <ng-container *ngIf="settings$ | async as settings">
          <img
            *ngIf="settings.logoUrl; else otpDefaultLogo"
            [src]="settings.logoUrl"
            [alt]="settings.logoAlt || 'Company Logo'"
            class="otp-logo">
          <ng-template #otpDefaultLogo>
            <img src="assets/tbds-common-logo.png" alt="The Big Data Showroom" class="otp-logo">
          </ng-template>
        </ng-container>
      </ng-template>
    </div>
    <mat-card-header>
      <mat-card-title>Two-Factor Verification</mat-card-title>
      <mat-card-subtitle>Please enter the 4 digit OTP sent to your email</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="otpForm" (ngSubmit)="onSubmit()">
        <div class="otp-entry">
          <div
            class="otp-digit-group"
            role="group"
            aria-label="OTP Code">
            <input
              #otpDigitInput
              *ngFor="let index of otpDigitIndexes"
              class="otp-digit-input"
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="1"
              [attr.autocomplete]="index === 0 ? 'one-time-code' : 'off'"
              [attr.aria-label]="'Digit ' + (index + 1) + ' of 4'"
              [disabled]="loading"
              (input)="onDigitInput(index, $event)"
              (keydown)="onDigitKeydown(index, $event)"
              (paste)="onDigitPaste($event)">
          </div>
          <div class="otp-error-slot">
            <p class="otp-error" *ngIf="showOtpError">
              OTP must be 4 digits
            </p>
          </div>
        </div>

        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="full-width submit-button"
          [disabled]="!isOtpComplete || loading">
          <mat-spinner diameter="20" *ngIf="loading" style="display: inline-block; margin-right: 8px;"></mat-spinner>
          {{ loading ? 'Verifying...' : 'Verify OTP' }}
        </button>
      </form>

      <div class="otp-actions">
        <button mat-button color="primary" type="button" (click)="resendOtp()" [disabled]="!canResendOtp">
          Resend OTP
        </button>
        <span class="resend-countdown" *ngIf="resendCountdownSeconds > 0">
          {{ resendCountdownDisplay }}
        </span>
        <button mat-button color="warn" type="button" (click)="logout()">
          Log Out
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
